import { gql } from '@apollo/client';
import { OptimizedImageFragment } from '../artikler/ArtikkelSEOFragment';

export const AnsattListFragment = gql`
  ${OptimizedImageFragment}
  fragment AnsattListFragment on Ansatt {
    id
    title
    slug
    ansattId
    ansatte {
      employeePhoto {
        node {
          ...OptimizedImageFragment
        }
      }
      role
      rekkefolge
      email
      linkedin
    }
  }
`;

/** Lightweight fields used to decide if an employee landing page is ready. */
export const ANSATT_LANDING_PRESENCE_FIELDS = `
  ansattLandingside {
    telefon
    littOmMeg
    videoHilsen {
      node {
        id
      }
    }
    tjenester {
      nodes {
        id
      }
    }
    artikler {
      nodes {
        id
      }
    }
    linkedinPoster {
      url
    }
  }
`;

export const AnsattLandingFields = `
  videoHilsen {
    node {
      mediaItemUrl
      mimeType
      mediaType
    }
  }
  telefon
  littOmMeg
  visLinkedinPoster
  linkedinPoster {
    url
  }
  tjenester {
    nodes {
      ... on Tjeneste {
        id
        title
        slug
        uri
        featuredImage {
          node {
            mediaItemUrl
            altText
          }
        }
        tjenesterPost {
          serviceDescription
        }
      }
    }
  }
  artikler {
    nodes {
      ... on Post {
        id
        title
        slug
        uri
        date
        excerpt
        categories {
          nodes {
            categoryId
            name
            slug
          }
        }
        featuredImage {
          node {
            mediaItemUrl
            altText
          }
        }
      }
    }
  }
`;

export const AnsattContentFragment = gql`
  ${OptimizedImageFragment}
  fragment AnsattContentFragment on Ansatt {
    id
    title
    slug
    uri
    modified
    ansatte {
      employeePhoto {
        node {
          ...OptimizedImageFragment
        }
      }
      role
      rekkefolge
      email
      linkedin
    }
  }
`;
